export default __webpack_public_path__ + "static/media/blank.c109395e.jpg";